'use strict';

var ClassClosureStrategyTemplatePreviewDirective = function ClassClosureStrategyTemplatePreviewDirective() {
  return {
    restrict: 'E',
    replace: true,
    require: '^rmTemplatePreview',
    template: require('../templates/class-closure-strategy-template-preview.html')
  };
};
ClassClosureStrategyTemplatePreviewDirective.$inject = [];
module.exports = ClassClosureStrategyTemplatePreviewDirective;